import { on } from '../lib/domUtils'

const initGA = () => {
  const desktopNavLinks = document.querySelectorAll('.desktop-nav .nav-item a')
  if (desktopNavLinks && desktopNavLinks.length) {
    for (let i = 0; i < desktopNavLinks.length; i += 1) {
      on(desktopNavLinks[i], 'click', () => {
        if (
          desktopNavLinks[i].innerText.indexOf('Dealer') ||
          desktopNavLinks[i].innerText.indexOf('DEALER')
        ) {
          window.gtag('event', 'Locate Dealer', {
            event_label: desktopNavLinks[i].innerText,
          })
        } else {
          window.gtag('event', 'navigation_click', {
            event_category: 'navigation',
            event_label: desktopNavLinks[i].innerText,
          })
        }
      })
    }
  }

  const mobileNavLinks = document.querySelectorAll('.mobile-nav .nav-item a')
  if (mobileNavLinks && mobileNavLinks.length) {
    for (let i = 0; i < mobileNavLinks.length; i += 1) {
      on(mobileNavLinks[i], 'click', () => {
        window.gtag('event', 'navigation_click', {
          event_category: 'navigation',
          event_label: mobileNavLinks[i].innerText,
        })
      })
    }
  }

  const jsGaTrackingLinks = document.querySelectorAll('.js-ga-tracking')
  if (jsGaTrackingLinks && jsGaTrackingLinks.length) {
    for (let i = 0; i < jsGaTrackingLinks.length; i += 1) {
      on(jsGaTrackingLinks[i], 'click', () => {
        if (
          jsGaTrackingLinks[i].innerText.indexOf('Buy') >= 0 ||
          jsGaTrackingLinks[i].innerText.indexOf('BUY') >= 0
        ) {
          window.gtag('event', 'Add to Cart', {
            event_label: jsGaTrackingLinks[i].innerText,
          })
        } else if (
          jsGaTrackingLinks[i].innerText.indexOf('Contact') >= 0 ||
          jsGaTrackingLinks[i].innerText.indexOf('CONTACT') >= 0
        ) {
          window.gtag('event', 'Contact Dealer', {
            event_label: jsGaTrackingLinks[i].innerText,
          })
        } else {
          window.gtag('event', 'product_click', {
            event_category: 'product_table',
            event_label: jsGaTrackingLinks[i].innerText,
          })
        }
      })
    }
  }
}

initGA()
